<template>
    <RoomList />
</template>

<script>
import RoomList from "@/components/RoomList.vue";


export default {
    name: 'RoomListView',
    components: {
        RoomList
    }
}
</script>